import { css } from 'lit';

export const skewedLabelStyles = css`
  fg-translation-wrapper:has(fg-hsp-label) {
    margin-top: 0.25rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .skewed-label {
    color: var(--fg-hsp-color, var(--fg-fallback-hsp-color));
    background: var(--fg-hsp-background, var(--fg-fallback-hsp-background));
    border-top-left-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
    display: inline-block;
    font-style: italic;
    font-weight: bold;
    height: 32px;
    position: relative;
    text-transform: uppercase;
    z-index: 10;

    &::before,
    &::after {
      background: var(--fg-hsp-background, var(--fg-fallback-hsp-background));
      border: 1px solid
        var(--fg-hsp-background, var(--fg-fallback-hsp-background));
      content: '';
      height: 100%;
      position: absolute;
      transform: skewX(-9deg);
      width: 0.5rem;
      z-index: 0;
    }

    &::before {
      border-top-left-radius: 0.5rem;
      left: -0.25rem;
      bottom: 0;
    }

    &::after {
      border-bottom-right-radius: 0.5rem;
      right: -0.25rem;
      top: 0;
    }

    span {
      align-items: center;
      display: inline-flex;
      height: 100%;
      padding: 0.375rem 0.25rem;
      position: relative;
      z-index: 10;
    }
    svg {
      margin-right: 0.25rem;
    }

    .small & {
      height: 20px;
      span.content {
        font-size: 0.75rem;
        line-height: 0.75rem;
        padding: 0.25rem;
      }
      svg {
        height: 12px;
        width: 12px;
      }
    }

    span.content.hsp-container-cell-content {
      padding: 0.125rem;
    }

    .hsp-container-cell-icon {
      svg {
        width: 18px;
        height: 18px;
      }
    }
  }

  .hsp-container-cell {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: 7px;
    margin-right: 7px;
    span {
      padding: 0px;
      font-size: 0.875rem;
    }
  }
`;
